/* =========================================================================
   AROMATEX · Brand Scent Advisor
   data.js — Catálogo de aromas + reglas de negocio (scoring / hard rules)
   ========================================================================= */

/* -------------------------------------------------------------------------
   1. CATÁLOGO DE AROMAS
   Fuente: Catálogo_de_Aromas_EXTENDIDO.pdf (Aromatex)
   ------------------------------------------------------------------------- */
const AROMA_CATALOG = {
  "Acapella Signature Scent": {
    family: "Amaderados",
    notes: { salida: "Madera de cedro", corazon: "Limón y ámbar", fondo: "Almizcle" },
    emotions: ["Seguridad", "Confianza", "Fuerza"],
    adjectives: ["Masculino", "Elegante", "Fresco"],
    spaceType: "espacios de lujo",
    industries: "Hoteles, recepciones",
    intensity: "Media",
  },
  "Baccarat & Cashmere": {
    family: "Amaderados",
    notes: { salida: "Azafrán y cedro", corazon: "Jazmín", fondo: "Ámbar gris" },
    emotions: ["Calma", "Madurez", "Seriedad"],
    adjectives: ["Femenino", "Lujoso", "Interesante"],
    spaceType: "espacios de lujo",
    industries: "Casas muestra de lujo, joyerías",
    intensity: "Media",
  },
  "Fiero": {
    family: "Amaderados",
    notes: { salida: "Brisa marina", corazon: "Madera de cedro y musgo", fondo: "Almizcle" },
    emotions: ["Calma", "Paciencia", "Inmensidad"],
    adjectives: ["Boscoso", "Firme", "Natural"],
    spaceType: "espacios masculinos",
    industries: "Espacios que imitan la sensación de un bosque",
    intensity: "Media",
  },
  "Mahogany Teakwood": {
    family: "Amaderados",
    notes: { salida: "Manzana y bergamota", corazon: "Cedro y caoba", fondo: "Coco y madera de teca" },
    emotions: ["Inteligencia", "Sofisticación", "Paz"],
    adjectives: ["Sutil dulce", "Naturaleza", "Unisex"],
    spaceType: "espacios elegantes",
    industries: "Hoteles, habitaciones",
    intensity: "Media",
  },
  "Rakaan": {
    family: "Amaderados",
    notes: { salida: "Madera de caoba", corazon: "Acorde floral", fondo: "Sándalo y ámbar" },
    emotions: ["Acogedor", "Suave", "Seguro"],
    adjectives: ["Amaderado", "Femenino", "Lo mejor de dos mundos"],
    spaceType: "espacios elegantes",
    industries: "Recepción, estancia",
    intensity: "Media",
  },
  "Maison Wynn": {
    family: "Amaderados",
    notes: { salida: "Melón y fresia", corazon: "Jazmín y azahar", fondo: "Almizcle blanco y frambuesa" },
    emotions: ["Energía", "Amor", "Confianza"],
    adjectives: ["Dulce", "Complejo", "Diferente"],
    spaceType: "espacios elegantes",
    industries: "Baños VIP, salas de aeropuertos",
    intensity: "Alta",
  },
  "Chrome": {
    family: "Cítricos",
    notes: { salida: "Bergamota y mandarina", corazon: "Rosa de Damasco y eucalipto", fondo: "Pachulí y tonka" },
    emotions: ["Energía", "Armonía", "Tranquilidad"],
    adjectives: ["Fresco", "Natural", "Paradisiaco"],
    spaceType: "espacios vacacionables",
    industries: "Hoteles de playa, baños",
    intensity: "Media",
  },
  "Citrus Peel": {
    family: "Cítricos",
    notes: { salida: "Bergamota, naranja y limón", corazon: "Citronela y lila", fondo: "Almizcle y ámbar" },
    emotions: ["Felicidad", "Paz", "Energía"],
    adjectives: ["Intensidad", "Limpieza", "Frescura"],
    spaceType: "espacios que necesitan transmitir limpieza",
    industries: "Baños, hospitales, consultorios",
    intensity: "Alta",
  },
  "Fresh Lemon Peel": {
    family: "Cítricos",
    notes: { salida: "Lavanda y limón", corazon: "Menta y mandarina", fondo: "Madera y ámbar" },
    emotions: ["Energía", "Felicidad", "Curiosidad"],
    adjectives: ["Limpieza", "Activación", "Frescura"],
    spaceType: "espacios que necesitan transmitir limpieza",
    industries: "Baños, hospitales, consultorios",
    intensity: "Alta",
  },
  "Maison W": {
    family: "Cítricos",
    notes: { salida: "Citronela y limón", corazon: "Musgo y cedro", fondo: "Almizcle y ámbar" },
    emotions: ["Optimismo", "Plenitud", "Elegancia"],
    adjectives: ["Limpieza", "Natural", "Profundo"],
    spaceType: "espacios elegantes pero no inalcanzables",
    industries: "Agencias de autos, oficinas",
    intensity: "Media",
  },
  "Ámbar White": {
    family: "Florales",
    notes: { salida: "Té verde", corazon: "Rosa y acordes florales", fondo: "Almizcle y ámbar" },
    emotions: ["Plenitud", "Elegancia", "Tranquilidad"],
    adjectives: ["Paz", "Natural", "Profundo"],
    spaceType: "espacios elegantes pero no inalcanzables",
    industries: "Agencias de autos, oficinas",
    intensity: "Media",
  },
  "Lavender Road": {
    family: "Florales",
    notes: { salida: "Lavanda", corazon: "Jazmín y lila", fondo: "Pachulí y almizcle" },
    emotions: ["Optimismo", "Felicidad", "Elegancia"],
    adjectives: ["Limpieza", "Paz", "Profundo"],
    spaceType: "espacios relajantes",
    industries: "Spas, boutiques femeninas",
    intensity: "Media",
  },
  "Noir Le Labo": {
    family: "Florales",
    notes: { salida: "Aguja de pino y menta", corazon: "Jazmín, violeta y rosa", fondo: "Almizcle" },
    emotions: ["Natural", "Felicidad", "Emoción"],
    adjectives: ["Profundidad", "Riqueza", "Limpieza"],
    spaceType: "espacios relajantes",
    industries: "Agencias de auto, casas muestra",
    intensity: "Media",
  },
  "Passion Orchids": {
    family: "Florales",
    notes: { salida: "Orquídea y rosa", corazon: "Lavanda y lirio", fondo: "Almizcle" },
    emotions: ["Felicidad", "Pasión", "Alegría"],
    adjectives: ["Fresco", "Femenino", "Intenso"],
    spaceType: "espacios femeninos",
    industries: "Spas, boutiques femeninas",
    intensity: "Media",
  },
  "Maison Aria": {
    family: "Gourmet",
    notes: { salida: "Vainilla y caña de azúcar", corazon: "Coco y jazmín", fondo: "Tallo de bambú" },
    emotions: ["Optimismo", "Elegancia", "Diversión"],
    adjectives: ["Dulce", "Diferente", "Reconocible"],
    spaceType: "espacios diferenciadores",
    industries: "Hoteles, oficinas, retail",
    intensity: "Alta",
  },
  "Green Comfort": {
    family: "Gourmet",
    notes: { salida: "Té verde y caña de azúcar", corazon: "Acorde floral", fondo: "Almizcle y tonka" },
    emotions: ["Paz", "Unidad", "Tranquilidad"],
    adjectives: ["Limpieza", "Calma", "Relajante"],
    spaceType: "espacios relajantes",
    industries: "Spas, boutiques femeninas",
    intensity: "Suave",
  },
  "Sandalwood Vanilla": {
    family: "Gourmet",
    notes: { salida: "Anís y vainilla", corazon: "Musgo y melón", fondo: "Sándalo blanco y coco" },
    emotions: ["Felicidad", "Ternura", "Profundidad"],
    adjectives: ["Dulce", "Especiado", "Llamativo"],
    spaceType: "espacios distintivos",
    industries: "Retail, tiendas, salones",
    intensity: "Media",
  },
  "Tropical Water": {
    family: "Gourmet",
    notes: { salida: "Citronela y manzana", corazon: "Jazmín, lavanda y rosa", fondo: "Musgo blanco y madera" },
    emotions: ["Optimismo", "Felicidad", "Esperanza"],
    adjectives: ["Frutal", "Dulce", "Fresco"],
    spaceType: "espacios vacacionales",
    industries: "Hoteles caribeños",
    intensity: "Media",
  },
  "Green Bamboo": {
    family: "Herbales",
    notes: { salida: "Té verde y bambú", corazon: "Naranja y bergamota", fondo: "Madera y ámbar" },
    emotions: ["Paz", "Conexión con uno mismo", "Tranquilidad"],
    adjectives: ["Suave", "Discreto", "Fresco"],
    spaceType: "espacios discretos",
    industries: "Espacios habitacionales o de larga permanencia",
    intensity: "Suave",
  },
  "Higo Verdal": {
    family: "Herbales",
    notes: { salida: "Higo y aguja de pino", corazon: "Gardenia Haitiana", fondo: "Pachulí, coco y cedro" },
    emotions: ["Vitalidad", "Felicidad", "Calma"],
    adjectives: ["Afrutado", "Boscoso", "Fuerte"],
    spaceType: "espacios distintivos pero no exagerados",
    industries: "Agencias de autos",
    intensity: "Media",
  },
  "My Way": {
    family: "Herbales",
    notes: { salida: "Eucalipto y madera de cedro", corazon: "Violeta y musgo", fondo: "Sándalo y almizcle" },
    emotions: ["Neutralidad", "Confianza", "Autenticidad"],
    adjectives: ["Presente", "Complejo", "Balanceado"],
    spaceType: "espacios discretos",
    industries: "Espacios habitacionales o de larga permanencia",
    intensity: "Media",
  },
  "Oriental Tea": {
    family: "Herbales",
    notes: { salida: "Bergamota y limón", corazon: "Lirio y naranja", fondo: "Almizcle y madera" },
    emotions: ["Calma", "Relajación", "Paz"],
    adjectives: ["Suave", "Discreto", "Fresco"],
    spaceType: "espacios discretos",
    industries: "Espacios habitacionales o cafeterías",
    intensity: "Suave",
  },
  "Palo Santo": {
    family: "Herbales",
    notes: { salida: "Incienso y romero", corazon: "Canela y cedro blanco", fondo: "Sándalo y pachulí" },
    emotions: ["Neutralidad", "Paz", "Espiritualidad"],
    adjectives: ["Fuerte", "Herbal", "Diferente"],
    spaceType: "espacios espirituales",
    industries: "Espacios de espiritualidad y misticismo",
    intensity: "Alta",
  },
  "White Tea Fig": {
    family: "Herbales",
    notes: { salida: "Higo y té verde", corazon: "Jazmín y flor de cananga", fondo: "Cedro y almizcle" },
    emotions: ["Vitalidad", "Felicidad", "Calma"],
    adjectives: ["Afrutado", "Boscoso", "Balanceado"],
    spaceType: "espacios distintivos pero no exagerados",
    industries: "Agencias de autos",
    intensity: "Media",
  },
  "Calming Waves": {
    family: "Neuroscents",
    notes: { salida: "Limón, naranja y hierbabuena", corazon: "Manzanilla, ashwagandha y rhodiola", fondo: "Cedro de Texas, eucalipto y geranio" },
    emotions: ["Neutralidad", "Paz", "Espiritualidad"],
    adjectives: ["Descanso", "Serenidad", "Adormilado"],
    spaceType: "espacios de relajación",
    industries: "Salas de masajes",
    intensity: "Media",
  },
  "Energy Rise": {
    family: "Neuroscents",
    notes: { salida: "Limón, naranja y albahaca", corazon: "Guaraná y jengibre", fondo: "Yuzu y bayas de enebro" },
    emotions: ["Vitalidad", "Felicidad", "Energía"],
    adjectives: ["Limpieza", "Activación", "Frescura"],
    spaceType: "lugares donde se necesita energía",
    industries: "Oficinas, salas de espera",
    intensity: "Media",
  },
  "Focus Mode": {
    family: "Neuroscents",
    notes: { salida: "Cedro y bayas de enebro", corazon: "Ginseng, gotu kola, bacopa", fondo: "Pachulí" },
    emotions: ["Concentración", "Inteligencia", "Paciencia"],
    adjectives: ["Pensamiento rápido", "Serenidad", "Control"],
    spaceType: "espacios de estudio o creación",
    industries: "Despachos, bibliotecas, salones de clase",
    intensity: "Media",
  },
  "Happy Paws": {
    family: "Neuroscents",
    notes: { salida: "Lavanda", corazon: "Semilla de calabaza y raíz de valeriana", fondo: "Naranja y romero" },
    emotions: ["Tranquilidad", "Frescura", "Paz"],
    adjectives: ["Serenidad", "Control", "Calma"],
    spaceType: "espacios para calma de mascotas",
    industries: "Veterinarias, estancias para mascotas, lugares pet-friendly",
    intensity: "Media",
  },
};

/* -------------------------------------------------------------------------
   2. SCORING RULES
   ------------------------------------------------------------------------- */
const SCORING = {
  industry: {
    "Hotel": { "Acapella Signature Scent": 25, "Mahogany Teakwood": 20, "Maison Aria": 12, "Tropical Water": 15, "Chrome": 12 },
    "Retail": { "Sandalwood Vanilla": 30, "Green Comfort": 25, "Maison Aria": 20, "Higo Verdal": 18, "Acapella Signature Scent": 15 },
    "Corporativo": { "Green Bamboo": 35, "Acapella Signature Scent": 30, "Higo Verdal": 25, "Green Comfort": 25, "My Way": 18, "Sandalwood Vanilla": -20, "Maison Aria": -20, "Tropical Water": -10 },
    "Oficina": { "Green Comfort": 30, "Higo Verdal": 28, "Acapella Signature Scent": 25, "Green Bamboo": 25, "Focus Mode": 20, "My Way": 15 },
    "Hospital": { "Citrus Peel": 35, "Fresh Lemon Peel": 35, "Green Comfort": 25, "White Tea Fig": 22, "Green Bamboo": 18, "Sandalwood Vanilla": -35, "Maison Aria": -35, "Tropical Water": -20, "Passion Orchids": -15 },
    "Clínica": { "Green Comfort": 35, "Green Bamboo": 28, "White Tea Fig": 25, "Citrus Peel": 22, "Fresh Lemon Peel": 22, "Calming Waves": 18 },
    "Dentista": { "Green Comfort": 35, "Green Bamboo": 30, "White Tea Fig": 25, "Citrus Peel": 20, "Fresh Lemon Peel": 20 },
    "Spa": { "Green Comfort": 35, "Oriental Tea": 30, "Calming Waves": 28, "Lavender Road": 25, "Ámbar White": 20, "White Tea Fig": 18 },
    "Veterinaria": { "Happy Paws": 100, "Citrus Peel": 35, "Fresh Lemon Peel": 35, "Green Bamboo": 20, "Green Comfort": 20 },
    "Baños de restaurante": { "Citrus Peel": 50, "Fresh Lemon Peel": 45, "Chrome": 25, "Maison W": 15 },
    "Despacho legal / contable / arquitectura": { "Acapella Signature Scent": 35, "Fiero": 30, "Mahogany Teakwood": 28, "My Way": 20, "Focus Mode": 18 },
    "Salón de fiestas infantiles": { "Maison Aria": 35, "Tropical Water": 30, "Sandalwood Vanilla": 25, "Energy Rise": 20 },
    "Agencia automotriz": { "Maison W": 30, "Ámbar White": 25, "Higo Verdal": 25, "White Tea Fig": 20, "Noir Le Labo": 18 },
    "Inmobiliaria / casa muestra": { "Baccarat & Cashmere": 30, "Rakaan": 25, "Noir Le Labo": 20, "Acapella Signature Scent": 20, "Mahogany Teakwood": 18 },
  },

  emotions: {
    "Confianza": { "Acapella Signature Scent": 25, "My Way": 20, "Baccarat & Cashmere": 15, "Maison Wynn": 15, "Green Comfort": 10 },
    "Tranquilidad": { "Green Comfort": 30, "Green Bamboo": 28, "Oriental Tea": 25, "Calming Waves": 25, "Ámbar White": 15 },
    "Elegancia": { "Acapella Signature Scent": 25, "Baccarat & Cashmere": 25, "Mahogany Teakwood": 22, "Maison W": 20, "Ámbar White": 18 },
    "Exclusividad": { "Baccarat & Cashmere": 30, "Acapella Signature Scent": 25, "Rakaan": 22, "Maison Wynn": 20 },
    "Energía": { "Energy Rise": 35, "Fresh Lemon Peel": 28, "Citrus Peel": 25, "Chrome": 22, "Maison Wynn": 15 },
    "Frescura": { "Green Bamboo": 30, "Citrus Peel": 25, "Fresh Lemon Peel": 25, "Chrome": 22, "Oriental Tea": 18 },
    "Limpieza": { "Citrus Peel": 35, "Fresh Lemon Peel": 35, "Green Comfort": 25, "Maison W": 20, "Ámbar White": 18 },
    "Concentración": { "Focus Mode": 45, "Green Comfort": 20, "Green Bamboo": 18, "My Way": 15 },
    "Diversión": { "Maison Aria": 30, "Tropical Water": 25, "Energy Rise": 20, "Sandalwood Vanilla": 18 },
    "Relajación": { "Calming Waves": 35, "Green Comfort": 30, "Oriental Tea": 25, "Lavender Road": 22 },
  },

  brand_personality: {
    "Elegante": { "Acapella Signature Scent": 25, "Baccarat & Cashmere": 25, "Mahogany Teakwood": 22, "Rakaan": 18 },
    "Premium": { "Baccarat & Cashmere": 30, "Acapella Signature Scent": 28, "Maison Wynn": 22, "Mahogany Teakwood": 20 },
    "Corporativa": { "Green Bamboo": 30, "Acapella Signature Scent": 25, "Higo Verdal": 22, "My Way": 20 },
    "Masculina": { "Fiero": 30, "Acapella Signature Scent": 25, "Mahogany Teakwood": 22, "Palo Santo": 15 },
    "Femenina": { "Lavender Road": 25, "Passion Orchids": 25, "Baccarat & Cashmere": 18, "Ámbar White": 18 },
    "Natural": { "Green Bamboo": 30, "Higo Verdal": 28, "Oriental Tea": 22, "Green Comfort": 20 },
    "Fresca": { "Green Bamboo": 28, "Citrus Peel": 25, "Fresh Lemon Peel": 25, "Chrome": 20 },
    "Divertida": { "Maison Aria": 30, "Tropical Water": 25, "Energy Rise": 20 },
    "Discreta": { "Green Bamboo": 30, "Oriental Tea": 25, "Green Comfort": 25, "My Way": 20 },
    "Diferente": { "Maison Aria": 25, "Palo Santo": 25, "Maison Wynn": 22, "Higo Verdal": 20 },
  },

  main_goal: {
    "Diferenciar mi marca": { "Maison Aria": 25, "Higo Verdal": 25, "Palo Santo": 20, "Sandalwood Vanilla": 18 },
    "Mejorar la experiencia del cliente": { "Green Comfort": 25, "Acapella Signature Scent": 22, "Green Bamboo": 20, "Mahogany Teakwood": 18 },
    "Crear identidad de marca": { "Acapella Signature Scent": 25, "Maison Aria": 22, "Baccarat & Cashmere": 20, "Green Comfort": 18 },
    "Incrementar permanencia": { "Green Comfort": 25, "Sandalwood Vanilla": 22, "Higo Verdal": 20, "Oriental Tea": 18 },
    "Mejorar ambiente laboral": { "Focus Mode": 30, "Green Comfort": 25, "Green Bamboo": 22, "Energy Rise": 18 },
    "Cubrir olores fuertes": { "Citrus Peel": 45, "Fresh Lemon Peel": 45, "Happy Paws": 30, "Chrome": 20 },
    "Transmitir limpieza": { "Citrus Peel": 35, "Fresh Lemon Peel": 35, "Green Comfort": 25, "Maison W": 20 },
    "Generar relajación": { "Calming Waves": 35, "Green Comfort": 30, "Oriental Tea": 25, "Lavender Road": 20 },
    "Aumentar concentración": { "Focus Mode": 45, "Green Comfort": 20, "My Way": 18, "Green Bamboo": 15 },
  },

  stay_time: {
    "Menos de 10 minutos": { allowIntensity: ["Media", "Alta"], bonusAlta: 10 },
    "10 a 30 minutos": { allowIntensity: ["Media"], bonusMedia: 10 },
    "30 a 60 minutos": { allowIntensity: ["Suave", "Media"], penaltyAlta: -20 },
    "Más de una hora": { allowIntensity: ["Suave", "Media"], bonusSuave: 15, penaltyAlta: -35 },
  },

  desired_intensity: {
    "Muy discreto": { bonusSuave: 20, penaltyAlta: -30 },
    "Natural y ligero": { bonusSuave: 15, bonusMedia: 8, penaltyAlta: -15 },
    "Notorio pero agradable": { bonusMedia: 20 },
    "Que sea parte importante de la experiencia": { bonusAlta: 20, bonusMedia: 10 },
  },
};

/* -------------------------------------------------------------------------
   3. HARD RULES
   ------------------------------------------------------------------------- */
const HARD_RULES = [
  {
    condition: { industry: ["Corporativo", "Oficina", "Hospital", "Clínica", "Dentista"] },
    action: "penalize",
    aromas: ["Maison Aria", "Sandalwood Vanilla", "Tropical Water"],
    points: -40,
    reason: "Evitar aromas demasiado dulces en espacios donde las personas permanecen mucho tiempo.",
  },
  {
    condition: { industry: ["Gimnasio"] },
    action: "penalize",
    aromas: ["Lavender Road", "Passion Orchids", "Baccarat & Cashmere"],
    points: -35,
    reason: "Evitar aromas muy florales o femeninos en espacios deportivos.",
  },
  {
    condition: { industry: ["Veterinaria"] },
    action: "force_include",
    aromas: ["Happy Paws"],
    minimumRank: 1,
    reason: "Happy Paws está diseñado para veterinarias y espacios pet friendly.",
  },
  {
    condition: { branches: ["Más de 20"] },
    action: "show_custom_fragrance_message",
    message: "Por el tamaño de tu operación, tu marca puede ser candidata para desarrollar una fragancia exclusiva.",
  },
];

/* -------------------------------------------------------------------------
   4. FORMATO DE RESULTADO / ARQUETIPOS
   ------------------------------------------------------------------------- */
const RESULT_FORMAT = {
  result_title: "Tu Perfil Olfativo de Marca",
  show: [
    "brand_archetype",
    "top_5_aromas",
    "recommended_intensity",
    "reasoning_per_aroma",
    "custom_fragrance_message_if_applicable",
    "cta_schedule_consultation",
  ],
};

const ARCHETYPES = {
  "Corporate Wellness": ["Corporativo", "Oficina", "Confianza", "Concentración", "Tranquilidad"],
  "Luxury Signature": ["Hotel", "Elegancia", "Exclusividad", "Premium"],
  "Fresh Clinical": ["Hospital", "Clínica", "Dentista", "Limpieza", "Frescura"],
  "Retail Experience": ["Retail", "Diferenciar mi marca", "Incrementar permanencia"],
  "Pet Friendly Care": ["Veterinaria", "Área de mascotas"],
  "Relax & Wellness": ["Spa", "Relajación", "Bienestar", "Tranquilidad"],
  "Family & Fun": ["Salón de fiestas infantiles", "Diversión", "Energía"],
};

const ARCHETYPE_LABELS = {
  "Corporate Wellness": "Bienestar Corporativo",
  "Luxury Signature": "Firma de Lujo",
  "Fresh Clinical": "Frescura Clínica",
  "Retail Experience": "Experiencia Retail",
  "Pet Friendly Care": "Pet Friendly Care",
  "Relax & Wellness": "Relajación & Bienestar",
  "Family & Fun": "Familiar & Divertido",
};

/* -------------------------------------------------------------------------
   5. MAPEOS entre las respuestas del quiz y las llaves de scoring
   (Las opciones del quiz no siempre coinciden 1:1 con las llaves del
   catálogo de reglas; aquí se documenta cada decisión de mapeo.)
   ------------------------------------------------------------------------- */
const MAPPINGS = {
  // Pantalla 2 -> industry keys de SCORING.industry
  industry: {
    "Hotel": "Hotel",
    "Retail": "Retail",
    "Corporativo": "Corporativo",
    "Hospital": "Hospital",
    "Clínica": "Clínica",
    "Gimnasio": null, // sin tabla propia; solo aplica hard rule de florales
    "Restaurante": "Baños de restaurante", // proxy más cercano del catálogo
    "Agencia automotriz": "Agencia automotriz",
    "Inmobiliaria": "Inmobiliaria / casa muestra",
    "Veterinaria": "Veterinaria",
    "Spa": "Spa",
    "Otro": null,
  },

  // Pantalla 3 (espacios) -> tablas de industry reutilizadas a peso reducido
  spaceToIndustryKey: {
    "Oficinas": "Oficina",
    "Baños": "Baños de restaurante",
  },
  spaceWeight: 0.5,

  // Pantalla 4 -> SCORING.emotions keys
  emotion: {
    "Exclusividad": "Exclusividad",
    "Tranquilidad": "Tranquilidad",
    "Profesionalismo": "Confianza",
    "Confianza": "Confianza",
    "Energía": "Energía",
    "Bienestar": "Relajación",
    "Calidez": "Tranquilidad",
    "Concentración": "Concentración",
    "Frescura": "Frescura",
    "Cercanía": "Confianza",
    "Relajación": "Relajación",
    "Diversión": "Diversión",
  },

  // Pantalla 5 -> SCORING.brand_personality keys
  personality: {
    "Elegante": "Elegante",
    "Moderna": "Diferente",
    "Minimalista": "Discreta",
    "Natural": "Natural",
    "Premium": "Premium",
    "Innovadora": "Diferente",
    "Seria": "Corporativa",
    "Amigable": "Divertida",
    "Sofisticada": "Elegante",
    "Fresca": "Fresca",
    "Disruptiva": "Diferente",
    "Juvenil": "Divertida",
    "Tecnológica": "Corporativa",
    "Tradicional": "Corporativa",
    "Masculina": "Masculina",
    "Femenina": "Femenina",
    "Neutra": "Discreta",
  },

  // Pantalla 6 -> SCORING.main_goal keys
  mainGoal: {
    "Diferenciar mi marca": "Diferenciar mi marca",
    "Mejorar la experiencia del cliente": "Mejorar la experiencia del cliente",
    "Crear un aroma exclusivo": "Crear identidad de marca",
    "Incrementar permanencia": "Incrementar permanencia",
    "Mejorar el ambiente laboral": "Mejorar ambiente laboral",
    "Reforzar mi identidad de marca": "Crear identidad de marca",
    "Cubrir olores desagradables": "Cubrir olores fuertes",
    "Otro": null,
  },

  // Pantalla 7 -> SCORING.stay_time keys
  stayTime: {
    "Menos de 10 minutos": "Menos de 10 minutos",
    "10-30 minutos": "10 a 30 minutos",
    "30-60 minutos": "30 a 60 minutos",
    "Más de una hora": "Más de una hora",
  },

  // Pantalla 9 -> SCORING.desired_intensity keys
  desiredIntensity: {
    "Muy discreto": "Muy discreto",
    "Natural": "Natural y ligero",
    "Notorio": "Notorio pero agradable",
    "Que se convierta en parte de la experiencia": "Que sea parte importante de la experiencia",
  },
};
